import { render, staticRenderFns } from "./OrderStatusTypeConfigDialog.vue?vue&type=template&id=3ab525f4&scoped=true"
import script from "./OrderStatusTypeConfigDialog.vue?vue&type=script&lang=js"
export * from "./OrderStatusTypeConfigDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab525f4",
  null
  
)

export default component.exports